import script from "./MediaVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaVideo.vue?vue&type=script&setup=true&lang=ts"

import "./MediaVideo.vue?vue&type=style&index=0&id=48902ed2&lang=scss"

const __exports__ = script;

export default __exports__